import React, { useEffect, useState } from 'react';
import { useLiceos } from '../../../application/liceos/hooks/useLiceos';
import ToolbarComponent from '../../ui/section';
import Input from '../../ui/input';
import { Row, Col } from '../../ui/grid';
import { PrimaryButton } from '../../ui/button';
import { ModalConfirm } from '../../ui/modal2';
import Loader from '../../ui/loader';

const NewLiceoPage = (props) => {
    const {
        createLiceo,
        updateLiceo,
        getLiceoById,
        isLoading,
        error
    } = useLiceos();

    const [formData, setFormData] = useState({
        name: '',
        address: '',
        region: '',
        city: '',
        status: 'active'
    });
    const [confirmSave, setConfirmSave] = useState(false);
    const [loading, setLoading] = useState(false);

    const isEdit = !!props.match?.params?.id;

    useEffect(() => {
        const id = props.match?.params?.id;
        if (id) {
            loadLiceo(id);
        }
    }, [props.match?.params?.id]);

    const loadLiceo = async (id) => {
        setLoading(true);
        try {
            const data = await getLiceoById(id);
            if (data) {
                setFormData({
                    name: data.name || '',
                    address: data.address || '',
                    region: data.region || '',
                    city: data.city || '',
                    status: data.status || 'active'
                });
            }
        } catch (err) {
            console.error('Error al cargar liceo:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async () => {
        setConfirmSave(false);
        setLoading(true);
        try {
            if (isEdit) {
                await updateLiceo(props.match.params.id, formData);
            } else {
                await createLiceo(formData);
            }
            props.history.push('/academia/liceos');
        } catch (err) {
            console.error('Error al guardar liceo:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading || isLoading) {
        return (
            <ToolbarComponent label={isEdit ? "Editar Liceo" : "Nuevo Liceo"} showBackButton={true} onBackClick={() => props.history.goBack()}>
                <Loader text="Cargando..." />
            </ToolbarComponent>
        );
    }

    return (
        <ToolbarComponent label={isEdit ? "Editar Liceo" : "Nuevo Liceo"} showBackButton={true} onBackClick={() => props.history.goBack()}>
            {error && (
                <div style={{ padding: '10px', background: '#FEE2E2', color: '#DC2626', borderRadius: '4px', marginBottom: '16px' }}>
                    {error}
                </div>
            )}
            <Row padding="0 20px">
                <br />
                <Col md={12}>
                    <Input 
                        label="Nombre" 
                        type="text" 
                        onChange={(e) => handleChange('name', e.target.value)} 
                        value={formData.name} 
                    />
                </Col>
                <Col md={12}>
                    <Input 
                        label="Dirección" 
                        type="text" 
                        onChange={(e) => handleChange('address', e.target.value)} 
                        value={formData.address} 
                    />
                </Col>
                <Col md={6}>
                    <Input 
                        label="Región" 
                        type="text" 
                        onChange={(e) => handleChange('region', e.target.value)} 
                        value={formData.region} 
                    />
                </Col>
                <Col md={6}>
                    <Input 
                        label="Ciudad" 
                        type="text" 
                        onChange={(e) => handleChange('city', e.target.value)} 
                        value={formData.city} 
                    />
                </Col>
                <Col md={12}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#6B7280' }}>
                        Estado
                    </label>
                    <select
                        value={formData.status}
                        onChange={(e) => handleChange('status', e.target.value)}
                        style={{
                            width: '100%',
                            padding: '10px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '6px',
                            fontSize: '14px'
                        }}
                    >
                        <option value="active">Activo</option>
                        <option value="inactive">Inactivo</option>
                    </select>
                </Col>
                <Col md={12} className="text-right">
                    <br />
                    <PrimaryButton 
                        onClick={() => setConfirmSave(true)} 
                        text={isEdit ? "Actualizar liceo" : "Crear liceo"} 
                    />
                </Col>
            </Row>
            <ModalConfirm 
                isOpen={confirmSave} 
                onClose={() => setConfirmSave(false)} 
                onAccept={handleSave}
                title={isEdit ? "¿Actualizar liceo?" : "¿Crear liceo?"}
                message={isEdit ? "Se actualizará la información del liceo." : "Se creará un nuevo liceo."}
            />
        </ToolbarComponent>
    );
};

export default NewLiceoPage;









